document.addEventListener(
  "octane.quiz.questionLoaded",
  () => {
    const backIcon = `
        <svg width="31" height="17" viewBox="0 0 31 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M31 8.5L1 8.5M1 8.5L8.5 1M1 8.5L8.5 16" stroke="currentColor" stroke-linejoin="round"/>
        </svg>
        `;

    const nextIcon = `
        <svg width="31" height="17" viewBox="0 0 31 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 8.5L30 8.5M30 8.5L22.5 1M30 8.5L22.5 16" stroke="currentColor" stroke-linejoin="round"/>
        </svg>
        `;

    const quizWrapper = document.querySelector(".oct-quiz-content");
    if (!quizWrapper) return;

    const observer = new MutationObserver(() => {
      const backButtons = document.querySelectorAll(
        'button.oct-quiz-btn[title="Back"]'
      );
      backButtons.forEach((btn) => {
        if (!btn.querySelector("svg")) {
          btn.insertAdjacentHTML("afterbegin", backIcon);
        }
      });

      const continueButtons = document.querySelectorAll(
        'button.oct-quiz-btn[title="CONTINUE"]'
      );
      continueButtons.forEach((btn) => {
        if (!btn.querySelector("svg")) {
          btn.insertAdjacentHTML("beforeend", nextIcon);
        }
      });

      const skipButtons = document.querySelectorAll(
        'button.oct-quiz-btn[title="Skip"]'
      );
      skipButtons.forEach((btn) => {
        const skipWrapper = btn?.closest(".oct-quiz-btn-wrapper");
        const backBtn = document.querySelector(
          'button.oct-quiz-btn[title="Back"]'
        );

        if (skipWrapper && backBtn && !skipWrapper.contains(backBtn)) {
          skipWrapper.insertBefore(backBtn, skipWrapper.firstChild);
        }

        if (!btn.querySelector("svg")) {
          btn.insertAdjacentHTML("beforeend", nextIcon);
        }
      });
    });

    observer.observe(quizWrapper, {
      childList: true,
      subtree: true,
    });
  },
  false
);
